import { Apple } from '@material-ui/icons'
import { WindowsIcon, UbuntuIcon, CentOSIcon } from 'Components/CustomIcons/Windows'
import { useMemo, useRef, useState } from 'react'

const useAgent = () => {
  const APP_LISTING = useRef([
    {
      type: 'AuthApp',
      name: 'Authenticator App',
      osName: {
        'Apple MacOs (x86_64)': {
          Icon: Apple,
          osRequirement: 'MacOS 10.14 or Above',
          link: 'https://ping-crestone.s3.us-west-2.amazonaws.com/crestone-agent-new/v2.0/downloads/mac/x64/PingOne+Privilege-x64-latest.pkg'
        },
        'Apple MacOs (Arm64)': {
          Icon: Apple,
          osRequirement: 'MacOS 10.14 or Above',
          link: 'https://ping-crestone.s3.us-west-2.amazonaws.com/crestone-agent-new/v2.0/downloads/mac/arm64/PingOne+Privilege-arm64-latest.pkg'
        },
        Windows: {
          Icon: WindowsIcon,
          osRequirement: 'Windows 7 or Above',
          link: 'https://ping-crestone.s3.us-west-2.amazonaws.com/crestone-agent-new/v2.0/downloads/win32/x64/PingOne+Privilege+Setup+x64-latest.exe'
        }
      },
      showDownloadButton: true
    },
    {
      type: 'AgentLess_Cli',
      name: 'AgentLess CLI',
      osName: {
        'Apple MacOs (x86_64)': {
          Icon: Apple,
          osRequirement: 'MacOS 10.14 or Above',
          link: 'https://ping-crestone.s3.us-west-2.amazonaws.com/crestone-agentless/mac/x64/PingOnePrivilegeCLI-latest-x64.pkg'
        },
        'Apple MacOs (Arm64)': {
          Icon: Apple,
          osRequirement: 'MacOS 10.14 or Above',
          link: 'https://ping-crestone.s3.us-west-2.amazonaws.com/crestone-agentless/mac/arm64/PingOnePrivilegeCLI-latest-arm64.pkg'
        },
        Windows: {
          Icon: WindowsIcon,
          osRequirement: 'Windows 7 or Above',
          link: 'https://ping-crestone.s3.us-west-2.amazonaws.com/crestone-agentless/windows/x64/PingOne+Privilege+CLI+Setup+latest.exe'
        }
      },
      showDownloadButton: true
    },
    {
      type: 'ServerAgent',
      name: 'Server Agent',
      osName: {
        CentOS: {
          Icon: CentOSIcon,
          osRequirement: 'RHEL/CentOS 7+ (x86_64)',
          link: 'https://ping-crestone.s3.us-west-2.amazonaws.com/server-guest-agent/rpm/procyon-server-agent-x86_64.rpm'
        },
        'Ubuntu AMD64': {
          Icon: UbuntuIcon,
          osRequirement: 'Debian/Ubuntu AMD64',
          link: 'https://ping-crestone.s3.us-west-2.amazonaws.com/server-guest-agent/debian/amd64/procyon-server-agent_amd64.deb'
        },
        'Ubuntu ARM64': {
          Icon: UbuntuIcon,
          osRequirement: 'Debian/Ubuntu ARM64',
          link: 'https://ping-crestone.s3.us-west-2.amazonaws.com/server-guest-agent/debian/arm64/procyon-server-agent_arm64.deb'
        }
      },
      showDownloadButton: false
    },
    {
      type: 'WindowAgent',
      name: 'Window Agent ',
      osName: {
        Windows: {
          Icon: WindowsIcon,
          osRequirement: 'Windows 7 or Above',
          link: 'https://ping-crestone.s3.us-west-2.amazonaws.com/windows-guest-agent/WindowsGuestAgent.exe'
        }
      },
      showDownloadButton: false
    },
    {
      type: 'LinuxAgent',
      name: 'Linux Agent',
      osName: {
        'RHEL/CentOS x86_64': {
          Icon: CentOSIcon,
          osRequirement: 'RHEL/CentOS 7+ (x86_64)',
          link: 'https://ping-crestone.s3.us-west-2.amazonaws.com/crestone-agent/linux/rpm/x86_64/procyon-agent-x86_64.rpm'
        },
        'RHEL/CentOS ARM64': {
          Icon: CentOSIcon,
          osRequirement: 'RHEL/CentOS 7+ (aarch64)',
          link: 'https://ping-crestone.s3.us-west-2.amazonaws.com/crestone-agent/linux/rpm/aarch64/procyon-agent-aarch64.rpm'
        },
        'Ubuntu AMD64': {
          Icon: UbuntuIcon,
          osRequirement: 'Debian/Ubuntu (amd64)',
          link: 'https://ping-crestone.s3.us-west-2.amazonaws.com/crestone-agent/linux/debian/amd64/procyon-agent_amd64.deb'
        },
        'Ubuntu ARM64': {
          Icon: UbuntuIcon,
          osRequirement: 'Debian/Ubuntu (arm64)',
          link: 'https://ping-crestone.s3.us-west-2.amazonaws.com/crestone-agent/linux/debian/arm64/procyon-agent_arm64.deb'
        }
      },
      showDownloadButton: false
    }
  ])

  const [activeDeviceOS, setActiveDeviceOS] = useState(() => {
    let Name = 'Mac'
    if (navigator.userAgent.indexOf('Win') !== -1) Name = 'Windows'
    if (navigator.userAgent.indexOf('Mac') !== -1) Name = 'Mac'
    return Name
  })

  const activeApp = useMemo(() => {
    const _activeApp = APP_LISTING.current.find((app) => app.osName[activeDeviceOS])
    return _activeApp || APP_LISTING.current[0]
  }, [activeDeviceOS])

  return {
    activeApp,
    activeDeviceOS,
    setActiveDeviceOS,
    APP_LISTING: APP_LISTING.current
  }
}

export default useAgent
